import { SystemEntity } from "@erp/shared-types";
import { z } from "zod";
import { defineStepConfig } from "../../registry/helpers";
import { entityOfType, SystemEntitySchema } from "../../utils/system-entities";

export const resolveShippingAssigneeStep = defineStepConfig({
  type: "resolve_shipping_assignee",
  name: "Resolve Shipping Assignee",
  description:
    "Collect email participants and customer watchers as ranked assignment candidates for a shipping-exception task",
  category: "Data Access",
  inputSchema: z.object({
    inboundEmail: entityOfType(SystemEntity.INBOUND_EMAIL),
    selectedEntity: SystemEntitySchema.optional(),
    taskMetadata: z.record(z.string(), z.unknown()),
  }),
  outputSchema: z.object({
    watcherUserIds: z
      .array(z.uuid())
      .describe(
        "Users to add as task watchers: email-thread participants plus watchers of the related customer",
      ),
    taskMetadata: z.record(z.string(), z.unknown()),
  }),
  configSchema: z.object({}),
  emits: [] as const,
});
